import { render, staticRenderFns } from "./MemberHomeComponent.vue?vue&type=template&id=34c642aa&scoped=true&"
import script from "./MemberHomeComponent.vue?vue&type=script&lang=js&"
export * from "./MemberHomeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c642aa",
  null
  
)

export default component.exports